export default __webpack_public_path__ + "static/media/joel.552a145b.png";